<template>
  <v-card v-if="att">
    <v-toolbar dense>
      <v-tooltip top v-if="id || $vuetify.breakpoint.smAndDown">
        <v-btn
          slot="activator"
          flat icon
          @click="id ? $router.go(-1) : $router.push({params: {id: undefined}})"
        >
          <v-icon>far fa-arrow-left</v-icon>
        </v-btn>
        <span>Back</span>
      </v-tooltip>
      <v-toolbar-title
        :style="att.stat === 'exempt' ? 'text-decoration: line-through;' : ''"
        class="text-capitalize"
      >
        <v-icon v-if="lock && att.stat === 'inprogress'">far fa-lock</v-icon>
        {{
          id
          ? proceduresFind({ query: { _id: { $in: att.proIds || []} } }).data
            .map(p=>p.name).join(', ')
          : 'New Clinical Session'
        }}
        <small v-if="id"><small>
          ({{ att.createdAt || 0 | moment('from') }})
          <span class="text-capitalize">
            {{ att.stat !== 'inprogress' ? `(${att.stat})` : ''}}
          </span>
        </small></small>
      </v-toolbar-title>
      <v-spacer />
      <v-tooltip top v-if="
        perm !== 'student'
        && (perm === 'admin' || att.stat === 'inprogress')
        && att.stat !== 'exempt'
      ">
        <v-btn flat icon @click="del = true" slot="activator">
          <v-icon>far fa-{{att.stat === 'inprogress' ? 'trash' : 'eraser'}}</v-icon>
        </v-btn>
        <span>{{att.stat === 'inprogress' ? 'Delete Session' : 'Mark Exempt'}}</span>
      </v-tooltip>
      <v-tooltip top v-if="perm === 'admin' && att.stat === 'exempt'">
        <v-btn flat icon @click="save('complete')" slot="activator">
          <v-icon>far fa-redo</v-icon>
        </v-btn>
        <span>Mark Un-Exempt</span>
      </v-tooltip>
    </v-toolbar>
    <v-dialog :value="del" v-if="perm !== 'student'" width="300">
      <v-card>
        <v-card-title class="headline">
          {{att.stat === 'inprogress' ? 'Delete' : 'Mark Exempt'}}?
          <br>
          Are you sure?
        </v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn flat @click.stop="del = false">Cancel</v-btn>
          <v-btn flat color="error" @click.stop="delCurrent">
            {{att.stat === 'inprogress' ? 'Delete' : 'Mark Exempt'}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card-title v-if="err">
      <report-error :error="err"/>
    </v-card-title>
    <v-stepper non-linear v-model="step" vertical>
      <v-stepper-step
        :complete="!!valid.step1"
        step="1"
        editable
        :edit-icon="$vuetify.icons.complete"
        :rules="[() => !errsStep1]"
      >
        Session Details
      </v-stepper-step>

      <stepper1
        :attempt="att"
        @update:attempt="Object.assign(att, $event)"
        :step.sync="step"
        :errs.sync="errs"
        :lock="lock"
        :valid.sync="valid.step1"
        @save="save"
        :loading="loading"
        :changed="changed"
      />

      <v-stepper-step
        :complete="!!valid.step2"
        step="2"
        :editable="att.patreq !== false && !!valid.step1"
        :disabled="att.patreq === false"
        :edit-icon="$vuetify.icons.complete"
        :rules="[() => !errsStep2]"
      >
        Patient Details
      </v-stepper-step>

      <stepper2
        :attempt.sync="att"
        :step.sync="step"
        :errs.sync="errs"
        :lock="lock"
        :valid.sync="valid.step2"
        @save="save"
        :loading="loading"
        :changed="changed"
      />

      <v-stepper-step
        :complete="!!valid.step1 && !!valid.step2 && !!valid.step3"
        step="3"
        :editable="!!valid.step1 && !!valid.step2"
        :edit-icon="$vuetify.icons.complete"
        :rules="[() => !errsStep3]"
      >
        Procedure Details
      </v-stepper-step>

      <stepper3
        :attempt.sync="att"
        :step.sync="step"
        :errs.sync="errs"
        :lock="lock"
        :valid.sync="valid.step3"
        @save="save"
        :loading="loading"
        :changed="changed"
      />

      <v-stepper-step
        :complete="!!valid.step4"
        step="4"
        v-if="perm !== 'student' || att.stat !== 'inprogress'"
        :editable="!!valid.step3"
        :edit-icon="$vuetify.icons.complete"
        :rules="[() => !errsStep4]"
      >
        Grading Details
      </v-stepper-step>

      <stepper4
        :attempt.sync="att"
        :step.sync="step"
        :errs.sync="errs"
        :lock="lock"
        :valid.sync="valid.step4"
        @save="save"
        :loading="loading"
        :changed="changed"
      />
    </v-stepper>
    <v-snackbar v-model="success" top multi-line :timeout="10000">
      <span class="success--text">Saved!</span>
      <br>
      <span v-if="!id">
        Your procedure is available for the supervisor to grade.<br>
        You will be able to modify this until two hours after the expected completion time.
      </span>
      <span v-if="id && perm === 'student'">Your procedure has been updated.</span>
      <span v-if="id && perm !== 'student' && att.stat === 'inprogress'">
        The procedure has been updated.
      </span>
      <span v-if="id && perm !== 'student' && att.stat === 'complete'">
        The procedure has been graded, the student can now see their grade. Thanks!
      </span>
      <span v-if="id && perm !== 'student' && att.stat === 'exempt'">
        The procedure has been marked as exempt.
      </span>
      <v-btn color="pink" flat icon @click="success = false">
        <v-icon>far fa-times</v-icon>
      </v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import set from 'lodash/set';
import attemptEq from './attemptEq';
import stepper1 from './steps/step-1.vue';
import stepper2 from './steps/step-2.vue';
import stepper3 from './steps/step-3.vue';
import stepper4 from './steps/step-4.vue';
import reportError from '../report-error.vue';

export default {
  components: {
    stepper1,
    stepper2,
    stepper3,
    stepper4,
    reportError,
  },
  data() {
    return {
      Attempt: this.$FeathersVuex.Attempt,
      att: { comments: {} },
      errs: { comments: {} },
      err: null,
      step: 1,
      del: false,
      valid: {
        step1: false,
        step2: false,
        step3: false,
        step4: false,
      },
      success: false,
      loading: false,
    };
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('attempts', ['get']),
    ...mapGetters('procedures', { proceduresFind: 'find' }),
    ...mapGetters('steps', { stepsFind: 'find' }),
    perm() { return this.user && this.user.perm; },
    id() { return this.att && this.att._id; },
    current() {
      let current = null;
      const { id } = this.$route.params;
      if (!id || id === 'new') {
        return new this.Attempt(
          this.perm === 'student'
            ? { studentId: this.user._id }
            : { supervisorId: this.user._id },
        );
      }
      if (this.loading) Math.random();
      current = this.get(id);
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      if (!current) return this.$router.push({ params: { id: undefined } });
      return current;
    },
    changed() { return !attemptEq(this.current, this.att); },
    lock() {
      if (this.att.stat !== 'inprogress') return true;
      if (!this.id || this.perm !== 'student') return false;
      const createdAt = (new Date(this.att.createdAt || 0)).getTime();
      return (120 + this.att.duration) < (Date.now() - createdAt) / 60000;
    },
    errsStep1() {
      Math.random(this.err);
      return this.errs.supervisorId || this.errs.locId || this.errs.unitId
        || this.errs.proIds || this.errs.duration;
    },
    errsStep2() { Math.random(this.err); return this.errs.patient || this.errs.patientDOB; },
    errsStep3() { Math.random(this.err); return this.errs.teeth || this.errs.stepIds; },
    errsStep4() {
      Math.random(this.err);
      return this.errs.grades || this.errs.comments.staff || this.errs.comments.staffPrivate;
    },
    stepIds() {
      const pros = this.proceduresFind({
        query: { _id: { $in: (this.att && this.att.proIds) || [] } },
      }).data;
      return pros.reduce((a, pro) => [...a, ...pro.stepIds], []);
    },
  },
  methods: {
    setAtt() {
      if (this.current) this.att = this.current.clone();
    },
    async save(stat = 'inprogress') {
      this.errs = { comments: {} };
      this.err = null;
      this.loading = true;
      this.att.stat = stat;
      if (!this.id) {
        delete this.att._id;
        if (this.perm === 'student') this.att.studentId = this.user._id;
        else this.att.supervisorId = this.user._id;
      }
      if (this.att.nopro) {
        this.att.teeth = [-1];
      }
      if (this.att.patreq === false) {
        this.att.patient = 'noPat';
      }
      try {
        this.att = await this.att.save();
        this.success = true;
        this.$emit('changed');
        if (this.att.stat !== 'inprogress' && /(grading)|(clinic)/.test(this.$route.path)) {
          await this.$router.push({ params: { id: undefined } });
        } else await this.$router.push({ params: { id: this.att._id } });
        this.setAtt();
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.error(err);
        if (!err.errors) {
          this.err = err;
          return;
        }
        Object.keys(err.errors).forEach((i) => {
          set(this.errs, i, err.errors[i].message);
        });
        this.err = {}; this.err = null;
      }
    },
    delCurrent() {
      this.del = false;
      if (this.att.stat === 'inprogress') return this.att.remove();
      return this.save('exempt');
    },
  },
  mounted() { this.setAtt(); this.$vuetify.icons.complete = 'fal fa-check'; },
  // updated() { if (!this.id && this.step > 1 && !this.step1) this.step = 1; },
  watch: {
    current() { this.setAtt(); },
    id() { if (!this.id) this.step = 1; },
    step(v) { if (v === 2 && this.att.patreq === false) this.step = 3; },
    async stepIds() {
      if (!this.stepIds.length) return;
      const steps = this.stepsFind({ query: { _id: { $in: this.stepIds } } }).data;
      const missingIds = this.stepIds.filter(id => !steps.some(step => step._id === id));
      if (missingIds.length) {
        await this.$store.dispatch('steps/find', { query: { _id: { $in: missingIds }, $limit: missingIds.length } });
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.grades-header >>> .v-icon
  font-size inherit
</style>
